import { render, staticRenderFns } from "./PartnerSchool.vue?vue&type=template&id=a496d5fa&scoped=true&"
import script from "./PartnerSchool.vue?vue&type=script&lang=js&"
export * from "./PartnerSchool.vue?vue&type=script&lang=js&"
import style0 from "./PartnerSchool.vue?vue&type=style&index=0&id=a496d5fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a496d5fa",
  null
  
)

export default component.exports